export default {
  loadingAnalysis: 'Cargando análisis...',
  generatingAnalysis: 'Generando análisis...',
  regenerating: 'Regenerando...',
  regenerateAnalysis: 'Regenerar análisis',
  regenerateConfirmMessage: 'Se generará un nuevo reporte que reemplazará al actual. ¿Deseas continuar?',
  regenerateConfirmTitle: 'Regenerar reporte',
  confirmRegenerate: 'Sí, regenerar',
  cancelRegenerate: 'No, mantener actual',
  adjustParameters: 'Ajustar parámetros del análisis',
  parameters: 'Parámetros',
  analysisParameters: 'Parámetros del análisis',
  temperatureLabel: 'Temperatura (creatividad):',
  temperatureHint: 'Recomendado: 0.2 para análisis preciso',
  maxTokensLabel: 'Máximo de tokens:',
  maxTokensHint: 'Recomendado: 6000 para análisis completo',
  analysisResult: 'Resultado del análisis:',
  printReport: 'Imprimir reporte',
  print: 'Imprimir',
  requestedBy: 'Solicitado por:',
  updatedAt: 'Actualizado:',
  cancelConfirmMessage: 'El análisis está en progreso. ¿Deseas cancelarlo?',
  cancelGeneration: 'Cancelar generación',
  confirmCancel: 'Sí, cancelar',
  continueGeneration: 'No, continuar',
  tokenLimitError: 'El análisis puede estar incompleto por límite de tokens.',
  generateError: 'Error al generar el reporte. Por favor intenta nuevamente.',
}
